import { motion } from 'motion/react';
import type { ReactNode } from 'react';

/** Pannello dei monitor: bordo, fondo e comparsa morbida all'avvio. Il padding lo decide chi lo usa. */
export function Panel({
  title,
  aside,
  titleClassName = 'text-title',
  className = '',
  children,
}: {
  title?: string;
  aside?: ReactNode;
  titleClassName?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`rounded-panel border border-line bg-panel ${className}`}
    >
      {title && (
        <div className="flex items-baseline justify-between">
          <h2 className={`font-semibold ${titleClassName}`}>{title}</h2>
          {aside}
        </div>
      )}
      {children}
    </motion.section>
  );
}
